import { render, staticRenderFns } from "./GeneralSocialMediaWidget.vue?vue&type=template&id=5f4a200f&scoped=true&"
import script from "./GeneralSocialMediaWidget.vue?vue&type=script&lang=js&"
export * from "./GeneralSocialMediaWidget.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSocialMediaWidget.vue?vue&type=style&index=0&id=5f4a200f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a200f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VHover,VImg,VSlideXTransition,VTooltip})
